import React, { FC } from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { ArrowTooltip } from '../tooltips';
import { useTranslation } from 'react-i18next';
import { usePopover } from '../../hooks';
import { IconButton } from '@material-ui/core';
import { AccountPopover } from './account-popover';

export const AccountButton: FC = () => {
  const { t } = useTranslation();
  const popover = usePopover<HTMLButtonElement>();

  return (
    <>
      <ArrowTooltip title={t('app-bar.user_profile')}>
        <IconButton
          color={"inherit"}
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
        >
          <AccountCircleIcon/>
        </IconButton>
      </ArrowTooltip>

      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};